export const types = {
  FETCHINGUSERIMAGES: 'AWSASYNC.FETCHINGUSERIMAGES',
  FETCHEDUSERIMAGES: 'AWSASYNC.FETCHEDUSERIMAGES',
  FETCHUSERIMAGESFAILED: 'AWSASYNC.FETCHUSERIMAGESFAILED',
  FETCHINGUSERIMAGEMETADATA: 'AWSASYNC.FETCHINGUSERIMAGEMETADATA',
  FETCHEDUSERIMAGEMETADATA: 'AWSASYNC.FETCHEDUSERIMAGEMETADATA',
  FETCHUSERIMAGEMETADATAFAILED: 'AWSASYNC.FETCHUSERIMAGEMETADATAFAILED',
  GETTINGS3IMAGESIGNEDURL: 'AWSASYNC.GETTINGS3IMAGESIGNEDURL',
  GETS3IMAGESIGNEDURL: 'AWSASYNC.GETS3IMAGESIGNEDURL',
  GETS3IMAGESIGNEDURLFAILED: 'AWSASYNC.GETS3IMAGESIGNEDURLFAILED',
  DOWNLOADINGALTERNATESIZE: 'AWSASYNC.DOWNLOADINGALTERNATESIZE',
  ALTERNATESIZEDONE: 'AWSASYNC.ALTERNATESIZEDONE'
};

export const fetchingUserImages = () => ({
  type: types.FETCHINGUSERIMAGES
});

export const fetchedUserImages = data => ({
  type: types.FETCHEDUSERIMAGES,
  data: data
});

export const fetchUserImagesFailed = () => ({
  type: types.FETCHUSERIMAGESFAILED
});

export const fetchingUserImageMetaData = () => ({
  type: types.FETCHINGUSERIMAGEMETADATA
});

export const fetchUserImageMetaData = (key, data) => ({
  type: types.FETCHEDUSERIMAGEMETADATA,
  key: key,
  data: data
});

export const fetchUserImageMetaDataFailed = () => ({
  type: types.FETCHUSERIMAGEMETADATAFAILED
});

export const getting_s3_signed_image_url = () => ({
  type: types.GETTINGS3IMAGESIGNEDURL
});

export const get_s3_signed_image_url = (
  imageKey,
  thumbKey,
  imageURL,
  thumbURL
) => ({
  type: types.GETS3IMAGESIGNEDURL,
  imageKey,
  thumbKey,
  imageURL,
  thumbURL
});

export const get_s3_signed_image_url_failed = () => ({
  type: types.GETS3IMAGESIGNEDURLFAILED
});

export const downloadingAlternateSize = (key, Size) => ({
  type: types.DOWNLOADINGALTERNATESIZE,
  key: key,
  Size: Size
});

export const alternateSizeDone = key => ({
  type: types.ALTERNATESIZEDONE,
  key: key
});



// WEBPACK FOOTER //
// ./src/store/actions/s3UserImages.js